<template>
    <modal-dialog
        id="confirm"
        :show.sync="shown"
        :dismissable="dismissable"
        :class="{ [`modal-${type}`]: true }"
        class="modal-confirmation"
    >
        <template v-slot:title>
            <span
                class="h5"
            >
                <open-icon
                    v-if="!!icon"
                    :glyph="icon"
                />
                {{ title }}
            </span>
        </template>
        <template v-slot:footer>
            <base-button
                @click.prevent="dismiss(false)"
                class="uk-margin-small-right"
            >
                {{ cancel }}
            </base-button>
            <base-button
                @click.prevent="dismiss(true)"
                :class="{ [`btn-${type}`]: true }"
                class="uk-margin-small-left"
            >
                {{ ok }}
            </base-button>
        </template>

        <p class="text-center">{{ message }}</p>
    </modal-dialog>
</template>

<script type="text/javascript">
import ModalDialog from "./ModalDialog"
import BaseButton from "../../ui/BaseButton"
import OpenIcon from "../../ui/OpenIcon"

export default {
    components: {
        ModalDialog,
        BaseButton,
        OpenIcon
    },
    methods: {
        dismiss (confirmed) {
            this.$emit("done", confirmed)
        }
    },
    computed: {
        shown: {
            get: function () {
                return true
            },
            set: function (show) {
                if(!show) this.dismiss(false)
            }
        }
    },
    props: {
        type: {
            type: String,
            validator: prop => !!prop && prop.match(/^(success|error|warning)$/),
            default: "warning",
            required: true
        },
        title: {
            type: String,
            default: "",
            required: true
        },
        message: {
            type: String,
            default: "",
            required: true
        },
        icon: {
            type: String,
            default: ""
        },
        dismissable: {
            type: Boolean,
            default: false
        },
        cancel: {
            type: String
        },
        ok: {
            type: String
        }
    }
}
</script>
